import script from "./NumberInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumberInput.vue?vue&type=script&lang=ts&setup=true"

import "./NumberInput.vue?vue&type=style&index=0&id=29bf7138&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bf7138"]])

export default __exports__